<template>
  <div class="form-row">
    <EstimatedNumberOfFramesField
      field="custom-dimension-3"
      placeholder="Geschat aantal ramen"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import EstimatedNumberOfFramesField from 'chimera/all/components/form/fields/estimatedNumberOfFrames/EstimatedNumberOfFramesField'

export default {
  name: 'EstimatedNumberOfFramesFormPart',

  components: {
    EstimatedNumberOfFramesField,
  },
}
</script>
